export default __webpack_public_path__ + "static/media/captura_plataforma1.4c5c76f7.png";